import { BadgeTokens } from './types';

export const badge: BadgeTokens = {
  css: {
    color: 'primary.50',
    bg: 'neutral.0',
    mr: '0', // TODO: try to use the space tokens defined in figma
    p: '1px', // TODO: try to use the space tokens defined in figma
    transform: 'none', // TODO: try to use tokens defined in figma
  },
};
